import React from 'react';
import { getApiUrl } from '../../utils';
import { message, Modal, Button } from 'antd';

class GSStore extends React.Component {
    constructor(props) {
        super(props);
        this.updateCustomerPrivacy = this.updateCustomerPrivacy.bind(this);
        this.getUserPrivacyInfo = this.getUserPrivacyInfo.bind(this);
        this.openStoreWindow = this.openStoreWindow.bind(this);
        this.state = {
            isModalVisible: false,
            gHasAcceptedPrivacy: undefined,
            latestPrivacyVersion: undefined,
            gLastAcceptedPrivacyVersion: undefined,
            gSPrivacyUrl: undefined
        };
    }

    componentDidMount() {
        this.getUserPrivacyInfo();
    }

    getUserPrivacyInfo() {
        fetch(getApiUrl() + "/gs/getGsPrivacyInfo", {
            method: 'GET',
            cache: 'no-cache',
            credentials: 'include',
            headers: new Headers({
                "Accept": 'application/json'
            }),
        })
            .then(res => res.json())
            .then(res => {
                if (res.error) throw res;

                const data = res.data;
                if (data) {
                    const hasAccepted = data.gHasAcceptedPrivacy === true;
                    this.setState({
                        gHasAcceptedPrivacy: data.gHasAcceptedPrivacy,
                        latestPrivacyVersion: data.latestPrivacyVersion,
                        gLastAcceptedPrivacyVersion: data.gLastAcceptedPrivacyVersion,
                        isModalVisible: !hasAccepted,
                        gSPrivacyUrl: data.gSPrivacyUrl
                    }, () => {
                        if (hasAccepted) {
                            this.openStoreWindow(); // ✅ apertura automatica
                        }
                    });
                }
            })
            .catch(err => {
                console.log("Errore nel recuperare i dati privacy:", err);
            });
    }

    updateCustomerPrivacy() {
        return fetch(getApiUrl() + "/gs/updateCustomerPrivacy", {
            credentials: "include",
            method: "POST",
            headers: new Headers({
                "Content-Type": 'application/json',
                "Accept": 'application/json'
            })
        });
    }

    openStoreWindow() {
        const height = window.screen.height * 0.85;
        const width = window.screen.width * 0.85;

        fetch(getApiUrl() + "/gs/getLoginUrl", {
            credentials: "include",
            headers: new Headers({
                "Accept": "application/json"
            })
        })
            .then(res => res.json())
            .then(res => {
                if (res.error) throw res.error;
                window.open(res.data, '_blank', `location=yes,height=${height},width=${width}`);
            })
            .catch(() => {
                message.error("Errore nell'apertura dello store Gomma Service");
            });
    }

    handleAccept = () => {
        this.setState({ isModalVisible: false });

        this.updateCustomerPrivacy()
            .catch(() => {
                message.warning("Errore nell'aggiornamento della privacy, procedo comunque.");
            })
            .finally(() => {
                this.openStoreWindow(); // ✅ apertura manuale dopo accettazione
            });
    };

    handleReject = () => {
        this.setState({ isModalVisible: false });
        message.info("Hai rifiutato l'informativa, operazione annullata.");
    };

    render() {
        return (
            <Modal
                title="Informativa Privacy"
                visible={this.state.isModalVisible}
                onCancel={this.handleReject}
                footer={[
                    <Button key="reject" onClick={this.handleReject}>
                        Rifiuto
                    </Button>,
                    <Button key="accept" type="primary" onClick={this.handleAccept}>
                        Accetto
                    </Button>
                ]}
            >
                <p>
                    Acconsento alla comunicazione dei miei dati (ragione sociale, email, indirizzo)
                    a partner commerciali di Sirmec SRL esclusivamente per finalità legate
                    all’evasione del mio ordine, come previsto dall’informativa privacy ai sensi
                    del Reg. UE 2016/679.
                    Link al documento completo: &nbsp;
                    <br />
                    <a href={this.state.gSPrivacyUrl} target="_blank" rel="noopener noreferrer">
                        {this.state.gSPrivacyUrl}
                    </a>
                </p>
            </Modal>
        );
    }
}

export default GSStore;
